const { each } = require('jquery');
const modal = require('../support/Modal');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */
$(function () {
    'use strict';

    /**
     * Show modal when section trigger it.
     */
    if ($('#ticketModal').length > 0) {
        modal.trigger($('#ticketModal'));
    }

    if ($('#triviaModal').length > 0) {
        modal.trigger($('#triviaModal'));
    }

    if ($('#rewardModal').length > 0) {
        modal.trigger($('#rewardModal'));
    }

    if ($('#experienceModal').length > 0) {
        modal.trigger($('#experienceModal'));
    }

    if ($('#cellersMigratedUsersModal').length > 0) {
        modal.trigger($('#cellersMigratedUsersModal'));
    }

    if ($('#btnCancelAccountModal').length > 0) {
        $('#btnCancelAccountModal').click(function () {
            modal.trigger($('#cancelAccountModal'));
        });

        // Show or hide textarea
        $('input[name="cancellation_reason"]').change(function () {
            if (this.checked && $(this).data('other')) {
                $('#cancellation_description_div').removeClass('hidden');
            } else {
                $('#cancellation_description_div').addClass('hidden');
            }
        });
    }

    if ($('#btnLoadChat').length > 0) {
        $('#btnLoadChat').on('click', function () {
            // Load Zendesk Widget script
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'ze-snippet';
            script.async = true;
            script.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + window.zendeskKey;
            document.getElementsByTagName('head')[0].appendChild(script);
            window.$zopim = null;

            // now wait for it to load...
            script.onload = () => {
                // Remove fake chat button
                $('#btnLoadChat').remove();
                // To show the chat window
                var intervalCheck = setInterval(
                    () => ($zopim ? ($zopim.livechat.window.show(), clearInterval(intervalCheck)) : ''),
                    1000
                );
            };
        });
    }

    $('.modal-services').on('click', (e) => {
        e.preventDefault();
        $('#urbanoMedModal ul').parent().animate({ scrollTop: 0 });
        $('.services-item').addClass('hidden');

        let service = $(e.currentTarget).attr('data-service');

        $('.services-item[data-service*="' + service + '"]').removeClass('hidden');

        modal.trigger($('#urbanoMedModal'));
    });
});
